// client/src/components/SideNav.js
// Section navigation for the account and admin areas: a sticky grouped list on
// larger screens, and a swipeable row of chips on phones so the page content
// isn't pushed below a long menu.
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Chip, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Stack, Typography,
} from '@mui/material';

const SideNav = ({ title, footer, groups }) => (
  <>
    <Stack
      direction="row"
      spacing={1}
      sx={{
        display: { xs: 'flex', md: 'none' }, overflowX: 'auto', mx: -2, px: 2, pb: 0.5,
        scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {groups.flatMap((group) => group.items).map((item) => (
        <Chip
          key={item.key}
          component={Link}
          to={item.to}
          clickable
          label={item.label}
          color={item.selected ? 'primary' : 'default'}
          variant={item.selected ? 'filled' : 'outlined'}
          sx={{ flexShrink: 0 }}
        />
      ))}
    </Stack>

    <Box sx={{ display: { xs: 'none', md: 'block' }, position: 'sticky', top: 128 }}>
      <Typography variant="h6" sx={{ px: 1.5, mb: 1 }}>{title}</Typography>
      {groups.map((group) => (
        <List
          key={group.title || 'main'}
          dense
          disablePadding
          sx={{ mb: 1.5 }}
          subheader={group.title && (
            <ListSubheader disableSticky sx={{ bgcolor: 'transparent', lineHeight: '32px', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', px: 1.5 }}>
              {group.title}
            </ListSubheader>
          )}
        >
          {group.items.map(({ key, label, to, icon: Icon, selected }) => (
            <ListItemButton key={key} component={Link} to={to} selected={selected} sx={{ py: 0.75, px: 1.5 }}>
              {Icon && (
                <ListItemIcon sx={{ minWidth: 32, color: 'inherit' }}>
                  <Icon sx={{ fontSize: 18 }} />
                </ListItemIcon>
              )}
              <ListItemText primary={label} primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: selected ? 700 : 500 }} />
            </ListItemButton>
          ))}
        </List>
      ))}
      {footer}
    </Box>
  </>
);

export default SideNav;
